webpackJsonp([25],{

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsPublicList_vue__ = __webpack_require__(1260);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72eb60b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsPublicList_vue__ = __webpack_require__(1388);
function injectStyle (ssrContext) {
  __webpack_require__(1385)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72eb60b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsPublicList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72eb60b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsPublicList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_SPLIT_KIND_NONE */
/* unused harmony export EVENT_SPLIT_KIND_REGULAR_SPLIT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL; });
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD */
// Mirror of App\Enums\EventSplitKind (campdraftone-api) — `split_kind` field, e.g. on
// EventNominationsDashboardResource. Not backed by a single DB column (derived from
// parent_id/brother_id/is_conjunction/children_count, see Event::splitKind()). Keep in sync by
// hand; there is no shared source of truth across the two repos. No labels here — this enum has
// none on the backend either, it's an internal classification, not something shown verbatim.
var EVENT_SPLIT_KIND_NONE = 'none';
var EVENT_SPLIT_KIND_REGULAR_SPLIT = 'regular_split';
var EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT = 'combined_unsplit_parent';
var EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD = 'combined_unsplit_child';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER = 'combined_conjunction_container';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD = 'combined_conjunction_child';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL = 'combined_conjunction_final';
var EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT = 'combined_split_side_parent';
var EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD = 'combined_split_side_child';

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__composables_draws_useDrawsPublicDashboard__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_eventSplitKind__ = __webpack_require__(1180);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DrawsPublicList',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */]
  },
  setup: function setup() {
    var _useDrawsPublicDashbo = Object(__WEBPACK_IMPORTED_MODULE_3__composables_draws_useDrawsPublicDashboard__["a" /* default */])(),
        drafts = _useDrawsPublicDashbo.drafts,
        loading = _useDrawsPublicDashbo.loading,
        fetchDashboard = _useDrawsPublicDashbo.fetchDashboard;

    function isSplitFinal(event) {
      return event.split_kind === __WEBPACK_IMPORTED_MODULE_4__constants_eventSplitKind__["a" /* EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL */];
    }

    function isEventVisible(event) {
      if (event.has_nominations) return true;
      if (isSplitFinal(event)) return true;
      return event.parent_draws_count > 0;
    }

    function eventDrawsCount(event) {
      if (event.draws_count > 0) return event.draws_count;
      if (event.parent_draws_count > 0) return event.parent_draws_count;
      return 0;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      fetchDashboard();
    });
    return {
      drafts: drafts,
      loading: loading,
      isEventVisible: isEventVisible,
      eventDrawsCount: eventDrawsCount
    };
  }
}));

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1386);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("2a79798a", content, true, {});

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".draws-dashboard__draft[data-v-72eb60b6]{border:1px solid #dee2e6}.draws-dashboard__header[data-v-72eb60b6]{background-color:#e9ecef;padding:.75rem 1rem;border-bottom:1px solid #dee2e6}.draws-dashboard__draft-name[data-v-72eb60b6]{font-size:1.25rem;font-weight:700}.draws-dashboard__events[data-v-72eb60b6]{list-style:none;margin:0;padding:0}.draws-dashboard__event[data-v-72eb60b6]{padding:.75rem 1rem;border-bottom:1px solid #dee2e6}.draws-dashboard__event[data-v-72eb60b6]:last-child{border-bottom:none}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Draws/PublicList/DrawsPublicList.vue"],"names":[],"mappings":"AACA,yCACE,wBAA0B,CAC3B,AACD,0CACE,yBAA0B,AAC1B,oBAAsB,AACtB,+BAAiC,CAClC,AACD,8CACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,0CACE,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,yCACE,oBAAsB,AACtB,+BAAiC,CAClC,AACD,oDACE,kBAAoB,CACrB","file":"DrawsPublicList.vue","sourcesContent":["\n.draws-dashboard__draft[data-v-72eb60b6] {\n  border: 1px solid #dee2e6;\n}\n.draws-dashboard__header[data-v-72eb60b6] {\n  background-color: #e9ecef;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n}\n.draws-dashboard__draft-name[data-v-72eb60b6] {\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n.draws-dashboard__events[data-v-72eb60b6] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.draws-dashboard__event[data-v-72eb60b6] {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n}\n.draws-dashboard__event[data-v-72eb60b6]:last-child {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDrawsPublicDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_draws__ = __webpack_require__(439);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useDrawsPublicDashboard() {
  var drafts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetchDashboard() {
    return _fetchDashboard.apply(this, arguments);
  }

  function _fetchDashboard() {
    _fetchDashboard = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getPublicDashboard();

            case 4:
              res = _context.sent;
              data = res.data.data;
              drafts.value = data.drafts != null ? data.drafts : [];
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              drafts.value = [];

            case 12:
              _context.prev = 12;
              loading.value = false;
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9, 12, 15]]);
    }));
    return _fetchDashboard.apply(this, arguments);
  }

  return {
    drafts: drafts,
    loading: loading,
    fetchDashboard: fetchDashboard
  };
}

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Draws")]),_vm._v(" "),(!_vm.loading && _vm.drafts.length === 0)?_c('div',{staticClass:"text-muted py-4 text-center"},[_vm._v("\n      No draws are currently available.\n    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.drafts),function(draft){return _c('div',{key:draft.id,staticClass:"mb-5"},[_c('div',{staticClass:"draws-dashboard__draft"},[_c('div',{staticClass:"draws-dashboard__header"},[_c('span',{staticClass:"draws-dashboard__draft-name"},[_vm._v(_vm._s(draft.name))])]),_vm._v(" "),(draft.events && draft.events.length)?_c('ul',{staticClass:"draws-dashboard__events"},[_vm._l((draft.events),function(event){return [(_vm.isEventVisible(event))?_c('li',{key:event.id,staticClass:"draws-dashboard__event"},[(_vm.eventDrawsCount(event) > 0)?_c('router-link',{attrs:{"to":("/draws/public/" + (event.id) + "/1")}},[_vm._v("\n                "+_vm._s(event.name)+"\n              ")]):_c('span',[_vm._v(_vm._s(event.name))])],1):_vm._e()]})],2):_vm._e()])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.6723ded829551fc9286d.js